import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import firebase from 'firebase';
import Vuetify from 'vuetify';

// Vuetify styles
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import 'vuetify/dist/vuetify.min.css';

Vue.config.productionTip = false;
Vue.use(Vuetify, {
  iconfont: 'md',
});

const LOCAL_DOMAINS = ['localhost', '127.0.0.1', ''];

const isDevMode = !!LOCAL_DOMAINS.includes(window.location.hostname);

// TODO: Move this out of main.ts
const firebaseConfig = {
  apiKey: 'AIzaSyApM_XWs6RB4TNalFSgMU7sqJVVyxojXFY',
  authDomain: 'greener-roots-farm.firebaseapp.com',
  databaseURL: 'https://greener-roots-farm.firebaseio.com',
  projectId: 'greener-roots-farm',
  storageBucket: 'greener-roots-farm.appspot.com',
  messagingSenderId: '664459031061',
};

const firebaseConfigDev = {
  apiKey: 'AIzaSyB_XdyBDu62heN43z4qxEGQGMorF8DKyF8',
  authDomain: 'greener-roots-farm-dev.firebaseapp.com',
  databaseURL: 'https://greener-roots-farm-dev.firebaseio.com',
  projectId: 'greener-roots-farm-dev',
  storageBucket: 'greener-roots-farm-dev.appspot.com',
  messagingSenderId: '755753189803',
  appId: '1:755753189803:web:a7235f8db6c422ef',
};

let app: any = '';

if (isDevMode) {
  firebase.initializeApp(firebaseConfigDev);

  firebase.initializeApp(firebaseConfigDev, 'Admin');
} else {
  firebase.initializeApp(firebaseConfig);

  firebase.initializeApp(firebaseConfig, 'Admin');
}

firebase.auth().onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      router,
      store,
      render: (h) => h(App),
   }).$mount('#app');
  }
});
